export const sidebarCategories = [
  {
    code: "SLOTS",
    path: "/slot",
    title: "สล็อต",
    icon: "mdi:slot-machine",
    settingKey: "sidebarSlotIconUrl",
  },
  {
    code: "CASINO",
    path: "/livecasino",
    title: "คาสิโนสด",
    icon: "cil:casino",
    settingKey: "sidebarCasinoIconUrl",
  },
  {
    code: "SPORTS",
    path: "/sportbook",
    title: "กีฬา",
    icon: "emojione-monotone:soccer-ball",
    settingKey: "sidebarSportIconUrl",
  },
  {
    code: "CARD",
    path: "/card",
    title: "เกมไพ่",
    icon: "mdi:cards-playing-outline",
    settingKey: "sidebarCardIconUrl",
  },
  {
    code: "KENO",
    path: "/keno",
    title: "หวย/คีโน่",
    icon: "game-icons:ticket",
    settingKey: "sidebarKenoIconUrl",
  },
  {
    code: "FISHING",
    path: "/fishing",
    title: "ยิงปลา",
    icon: "game-icons:spearfishing",
    settingKey: "sidebarFishIconUrl",
  },
];

export const fullWidthSidebarRoutes = [
  "/slot",
  "/livecasino",
  "/sportbook",
  "/card",
  "/keno",
  "/fishing",
];
